import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'assessments/v4';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('assessments/', '')
      .toLowerCase();
  }
}
